export class UploadFile {
  constructor () {
      this.header = ['DIV_KUBUN','BIZ_KUBUN','SITE_CODE','USER_KUBUN','SUB_DIR','RENAME_YN','FILE_NAME','file'];
      this.data = [{
        DIV_KUBUN: '',
        BIZ_KUBUN: '',
        SITE_CODE: '',
        USER_KUBUN: '',
        SUB_DIR: '',
        RNAME_YN: '',
        FILE_NAME: '',
        file:''
      }];
  }
}